export default __webpack_public_path__ + "static/media/caera-2.07899c79.webm";